/**
 * Pure helpers for the dictionary's search-mode state machine.
 *
 * Kept separate from bliss-dictionary.js so the logic can be unit-tested in
 * Node without loading the Lit component (which pulls in wa-input,
 * design-tokens, …).
 */

/**
 * Compute the state changes needed when the app navigates to a text query
 * (a B-code or BCI id) — e.g. the user clicked a result's SVG or a
 * derivation-part link.
 *
 * Such a navigation is inherently a *text* search. If a shape search was
 * active, the app must leave shape-search mode; otherwise the search-mode
 * toggle stays on "shape", the input keeps its shape-mode inputmode/styling,
 * the previous shape chips stay on screen, and the history state is rewritten
 * back to `?sq=` — leaving the user stuck in the wrong mode with a stale query.
 *
 * @param {boolean} shapeSearchIsActive Whether shape-search mode is active.
 * @returns {null | {shapeSearchIsActive: boolean, shapeSelectorIsActive: boolean, shapeSearchString: string, shapeSearchCodes: string[]}}
 *   `null` when already in text mode (nothing to reset); otherwise the patch of
 *   fields to apply so the app returns to a clean text-search state.
 */
export function shapeResetForTextNavigation(shapeSearchIsActive) {
  if (!shapeSearchIsActive) return null;
  return {
    shapeSearchIsActive: false,
    shapeSelectorIsActive: false,
    shapeSearchString: "",
    shapeSearchCodes: [],
  };
}
